import React from 'react';
import { useTranslation } from 'react-i18next';

export interface ParamItem { name: string; value: string }

interface Props {
  items: ParamItem[];
  onChange: (items: ParamItem[]) => void;
  title?: string;
}

/** 노드 변수/파라미터 편집 — 이름/값 표. 본문에서 ${이름} 으로 참조하며 실행 conf > 여기 > 전역변수 순으로 치환된다. */
const ParamsEditor: React.FC<Props> = ({ items, onChange, title }) => {
  const { t } = useTranslation();
  const rows = Array.isArray(items) ? items : [];
  const update = (i: number, patch: Partial<ParamItem>) => onChange(rows.map((r, k) => (k === i ? { ...r, ...patch } : r)));
  const bad = (n: string) => !!n && !/^[A-Za-z_][A-Za-z0-9_]*$/.test(n);
  return (
    <div className="mb-3 rounded border border-gray-200 p-2">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs font-semibold text-gray-600">{title || t('property:params.title')}</span>
        <button type="button" className="px-2 py-0.5 text-xs rounded border border-gray-300 bg-white hover:bg-gray-100 text-gray-700"
          onClick={() => onChange([...rows, { name: '', value: '' }])}>{t('property:params.add')}</button>
      </div>
      {rows.length === 0 ? (
        <div className="text-xs text-gray-400">{t('property:params.empty')} <code>{'${name}'}</code>{t('property:params.emptyTail')}</div>
      ) : (
        <table className="w-full text-xs">
          <thead><tr className="text-left text-gray-500"><th className="py-0.5 w-[40%]">{t('property:params.name')}</th><th className="py-0.5">{t('property:params.value')}</th><th className="w-6"></th></tr></thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td className="py-0.5 pr-1">
                  <input className={`w-full border rounded px-1 py-0.5 bg-white font-mono ${bad(r.name) ? 'border-red-400' : 'border-gray-300'}`} value={r.name}
                    placeholder="NAME" onChange={(e) => update(i, { name: e.target.value })} title={bad(r.name) ? t('property:params.badName') : ''} />
                </td>
                <td className="py-0.5 pr-1">
                  <input className="w-full border border-gray-300 rounded px-1 py-0.5 bg-white font-mono" value={r.value}
                    placeholder={t('property:params.valuePlaceholder')} onChange={(e) => update(i, { value: e.target.value })} />
                </td>
                <td className="py-0.5 text-gray-500"><button type="button" className="hover:text-red-500" title={t('property:params.remove')} onClick={() => onChange(rows.filter((_, k) => k !== i))}>✕</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ParamsEditor;
